import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getRoi, getRoi_currency } from "@/api/dataAll/roi";
import * as echarts from "echarts";
export default {
  name: "roi",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      value2: [],
      searchData: {
        start_time: "",
        end_time: "",
        country: "",
        self_design_day: ""
      },
      roiList: [{
        label: this.$t('roiPercent'),
        value: "per"
      }, {
        label: this.$t('roiCurrentDayRecharge'),
        value: "rec"
      }],
      tableData: [],
      cyclicData: [],
      dates: [],
      datas: [],
      series: [],
      cellStylekeys: ["roiAndrecharge"],
      roi: '',
      rawList: []
    };
  },
  watch: {
    roi: function roi(newVal) {
      // 如果当前表格有数据，说明用户已经搜索过，此时直接重新触发 searchClick 即可
      if (this.rawList && this.rawList.length > 0) {
        this.searchClick(this.rawList);
      }
    }
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqFn = _this.currencyClose ? getRoi_currency : getRoi;
                _this.reqLoading = true;
                _context.next = 4;
                return _this.getexchangeRate();

              case 4:
                _this.searchClickPoints(reqFn, 1, ['start_time', 'end_time']);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(list) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var num, res, totalRecharge, totalRoi, newData, i, roiList, rechargeList, k, _loop, _k, _k2, allRe, _i, finalRoi, finalRec;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.rawList = list;
                num = _this2.$times.getDayAll(_this2.value2[0], _this2.$times.timestampToTime(_this2.$times.zeroTimeZone() / 1000, 'YY-MM-DD')).length;
                res = {
                  data: {
                    cost: {},
                    recharge: {},
                    recharge_all: {},
                    roi: {}
                  }
                };
                list.forEach(function (i) {
                  for (var k in res.data) {
                    res.data[k] = _objectSpread(_objectSpread({}, res.data[k]), i[k]);
                  }
                });
                totalRecharge = {};
                totalRoi = {
                  cost: 0,
                  date: _this2.$t('weightedAverageRoi'),
                  recharge_all: 0,
                  exchange: 0
                };
                _this2.dates = [];
                _this2.series = [];
                _this2.cyclicData = [];
                _this2.datas = [];
                _this2.tableData = [];
                _context2.next = 13;
                return _this2.timeInterval();

              case 13:
                newData = JSON.parse(JSON.stringify(res.data));

                for (i in newData.roi) {
                  roiList = [];
                  rechargeList = [];

                  for (k in newData.roi[i]) {
                    roiList.push({
                      label: k,
                      value: newData.roi[i][k]
                    });
                    rechargeList.push({
                      label: k,
                      value: newData.recharge[i][k]
                    });
                    totalRecharge[k] = 0;
                  } // for (let k in newData.recharge[i]) {
                  //   rechargeList.push({
                  //     label: k,
                  //     value: newData.recharge[i][k],
                  //   });
                  // }


                  newData.roi[i] = roiList;
                  newData.recharge[i] = rechargeList;
                }

                _loop = function _loop(_k) {
                  var data = {
                    date: _k,
                    cost: _this2.$utils.conversion(newData.cost[_k]),
                    recharge_all: _this2.isyjfmvnd() ? newData.recharge_all[_k] : _this2.$utils.conversion(newData.recharge_all[_k]),
                    exchange: _this2.isyjfmvnd() ? newData.recharge_all[_k] * _this2.exchangeRate : _this2.$utils.conversion(newData.recharge_all[_k] * _this2.exchangeRate).toFixed(2)
                  };
                  totalRoi.cost = totalRoi.cost + newData.cost[_k];
                  totalRoi.recharge_all = totalRoi.recharge_all + data.recharge_all;
                  totalRoi.exchange = Number(totalRoi.exchange) + Number(data.exchange);

                  _this2.dates.push(_k);

                  newData.roi[_k].map(function (item, index) {
                    var n = item.label;
                    var roiVal = Number(item.value).toFixed(3);
                    var recVal = _this2.isyjfmvnd() ? newData.recharge[_k][index].value : _this2.$utils.conversion(newData.recharge[_k][index].value).toFixed(3); // --- 核心修改部分：根据 ROI 选择器处理数据展示 ---

                    if (_this2.roi === 'per') {
                      data["roiAndrecharge" + n] = roiVal;
                    } else if (_this2.roi === 'rec') {
                      data["roiAndrecharge" + n] = recVal;
                    } else {
                      data["roiAndrecharge" + n] = roiVal + " / " + recVal;
                    } // --------------------------------------------


                    data["roi" + n] = item.value;
                    totalRecharge[n] = (totalRecharge[n] || 0) + newData.recharge[_k][index].value;

                    if (_this2.cyclicData.length < newData.roi[_k].length) {
                      // --- 核心修改部分：根据 ROI 选择器处理表头名称 ---
                      var headerLabel = "";
                      var tableText = "";

                      if (_this2.roi === 'per') {
                        headerLabel = "".concat(_this2.$t('roiLabel')).concat(n);
                        tableText = n == 0 ? "".concat(_this2.$t('roiLabel')).concat(n, "A") : "".concat(_this2.$t('roiLabel')).concat(n);
                      } else if (_this2.roi === 'rec') {
                        headerLabel = "".concat(_this2.$t('currentDayRechargeLabel')).concat(n);
                        tableText = n == 0 ? "".concat(_this2.$t('currentDayRechargeLabel')).concat(n, "A") : "".concat(_this2.$t('currentDayRechargeLabel')).concat(n);
                      } else {
                        headerLabel = _this2.$t('roiSlashRecharge', {
                          day: n
                        });
                        tableText = n == 0 ? _this2.$t('roiSlashRecharge', {
                          day: n
                        }) + 'A' : _this2.$t('roiSlashRecharge', {
                          day: n
                        });
                      }

                      _this2.cyclicData.push({
                        label: headerLabel,
                        prop: "roiAndrecharge" + n,
                        desc: n == 0 ? _this2.$t('firstDayRoi') : "",
                        tableText: tableText
                      }); // --------------------------------------------


                      _this2.datas.push("roi" + n);
                    }
                  });

                  _this2.series.push({
                    name: _k,
                    type: "line",
                    data: newData.roi[_k].map(function (i) {
                      return i.value.toFixed(3);
                    }),
                    smooth: true
                  });

                  _this2.tableData.push(data);
                };

                for (_k in newData.roi) {
                  _loop(_k);
                }

                for (_k2 in totalRecharge) {
                  allRe = 0;

                  for (_i = 0; _k2 > _i; _i++) {
                    allRe = allRe + (totalRecharge[_i + 1] || 0);
                  }

                  finalRoi = totalRoi.cost == 0 || !allRe ? '0.000' : (allRe / totalRoi.cost).toFixed(3);
                  finalRec = _this2.isyjfmvnd() ? allRe : _this2.$utils.conversion(allRe).toFixed(3);

                  if (_this2.roi === 'per') {
                    totalRoi["roiAndrecharge" + _k2] = num > Number(_k2) - 1 ? finalRoi : '0.000';
                  } else if (_this2.roi === 'rec') {
                    totalRoi["roiAndrecharge" + _k2] = num > Number(_k2) - 1 ? finalRec : '0.000';
                  } else {
                    totalRoi["roiAndrecharge" + _k2] = num > Number(_k2) - 1 ? "".concat(finalRoi, " / ").concat(finalRec) : '0.000 / 0.000';
                  }
                }

                totalRoi.cost = totalRoi.cost ? _this2.$utils.conversion(totalRoi.cost).toFixed(2) : 0; // totalRoi.recharge_all = totalRoi.recharge_all ? this.$utils.conversion(totalRoi.recharge_all).toFixed(2) : 0;

                _this2.tableData.push(totalRoi);

                _this2.$nextTick(function () {
                  _this2.getechart();

                  _this2.getTableRight();
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("roiEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dates = this.dates;
      var datas = this.datas;
      var series = this.series;
      option = {
        title: {
          text: "ROI"
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dates,
          // selected: this.selectedArr,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: datas
        },
        yAxis: {
          type: "value"
        },
        series: series
      };
      option && myChart.setOption(option, true);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.page = val;
      this.searchClick();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('rechargeAllSlashEarnings'),
        prop: "recharge_all"
      }, {
        label: this.$t('costSlashPay'),
        prop: "cost"
      }].concat(_toConsumableArray(this.cyclicData));
      var exchangeUSD = JSON.parse(JSON.stringify(this.exchangeUSD));
      var exchangeVND = JSON.parse(JSON.stringify(this.exchangeVND));

      if (this.queryCurrency == "USD") {// exchangeUSD.unshift(2, 0);
        // Array.prototype.splice.apply(columns, exchangeUSD);
      }

      if (this.queryCurrency == "VND") {
        exchangeVND.unshift(2, 0);
        Array.prototype.splice.apply(columns, exchangeVND);
      }

      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};